import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class EnrollmentService {
    /**
    * Enrolls a new policy or account for the current user
    *
    * @param {Object} data enrollment data
    * @param {Object} additionalHeaders additional headers to pass to the backend (e.g. auth)
    * @returns {Promise} the promise from the backend call
    */

    /* TDIC - Following method has changed based on requirement.
     static addEnrollmentRecord(data, additionalHeaders = {}) {
        return JsonRPCService
        .send(getProxiedServiceUrl('policyEnrollment')
        , 'addEnrollmentRecord', [data], additionalHeaders);
    } */
    // TDIC - Added - Following method to add enrollment record.
    static addEnrollmentRecord(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'addEnrollmentRecord_Ext', [data], additionalHeaders);
    }

    // TDIC - Added - Following method to update enrollment record.
    static updateEnrollmentRecord(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'updateEnrollmentRecord', [], additionalHeaders);
    }

    static hasADAAuthority(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'hasADAAuthority', [], additionalHeaders);
    }
}
